export default class LoginData {
  loginID = '';
  otpTimeout = 0;

  constructor(loginID: string, otpTimeout?: number) {
    this.loginID = loginID;
    this.otpTimeout = otpTimeout || 0;
  }
}
